























































































































































































































































import { Prop, Component, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { MyOptions } from "@/charts/graphData";
import { mixins } from "vue-class-component";
import chartsMixin from "./chartsMixin";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";
import MobileMixin from "@/mixins/mobileMixin";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class CaDataBg extends mixins(chartsMixin, MobileMixin) {
  public value = { CA: 0, Couverts: 0, Tickets: 0, Tables: 0 };
  public config: any;
  public WS: any;
  public testMemeHeure = false;
  public reRender = false;
  public configIsReady = false;
  public cachedResumeDataItem: any = null;
  @Prop() public myOptions!: MyOptions;
  @Prop() public info!: string;
  @Prop() public isTTC!: boolean;
  @Prop() public CAParService!: { [key: string]: number };
  @Prop({ default: 0 }) public CA!: number;
  @Prop() public TicketsEtCouverts!: { [key: string]: string };
  @Prop() public type!: string;
  @Prop({ default: 0 }) public CACouverts!: number;
  @Prop() public CATickets!: number;
  @Prop({ default: 0 }) public CATables!: number;
  public CACouvertsReel: number = 0;
  public CATicketsReel: number = 0;
  public CATablesReel: number = 0;
  public isSecond: boolean = false;

  public mounted() {
    this.isSecond = ["Hier", "Semaine dernière", "Mois dernier", "Année dernière"].includes(this.info);
    this.init();
  }

  @Watch("isTTC")
  public onTTCChanged(newValue: boolean, oldValue: boolean) {
    // Si on a des données historiques en cache et que TTC change
    if (oldValue !== undefined && newValue !== oldValue && this.cachedResumeDataItem) {
      console.log(`CaDataBg ${this.info}: isTTC changed to ${newValue}, updating values from cache`);
      this.updateValuesFromCachedData();
    }
  }

  public async init() {
    // console.log("ca bg data");
    // console.log(this.info);
    this.config = {
      site: this.getGlobal ? this.myOptions.site : this.myOptions.site[0],
      periode: "J",
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
      profit: [],
      localisation: "",
      service: this.myOptions.service,
      horodatage: "",
      title: "",
      client: this.client,
    };
    this.WS = {};

    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    const todayDate = yyyy + "-" + mm + "-" + dd;
    const hh = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const ss = String(today.getSeconds()).padStart(2, "0");
    const dateChosen = new Date(this.config.date);

    this.CACouvertsReel = this.CACouverts;
    this.CATicketsReel = this.CATickets;
    this.CATablesReel = this.CATables;

    let dd2: string;
    let mm2: string;
    let yyyy2: number;
    // console.log("ca bg data");
    // console.log(this.info);
    switch (this.info) {
      case "Hier":
        const yesterday = new Date(this.config.date);
        yesterday.setDate(yesterday.getDate() - 1);
        dd2 = String(yesterday.getDate()).padStart(2, "0");
        mm2 = String(yesterday.getMonth() + 1).padStart(2, "0");
        yyyy2 = yesterday.getFullYear();
        if (this.config.date !== todayDate || this.isMobile()) {
          this.config.horodatage = yyyy2 + "-" + mm2 + "-" + dd2;
          this.config.title = yesterday.toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } else {
          this.testMemeHeure = true;
          this.config.horodatage =
              yyyy2 + "-" + mm2 + "-" + dd2 + " " + hh + ":" + minutes + ":" + ss;
          this.config.title =
              yesterday.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              hh +
              "h" +
              minutes;
        }
        break;
      case "Semaine dernière":
        const lastWeek = new Date(this.config.date);
        lastWeek.setDate(lastWeek.getDate() - 7);
        dd2 = String(lastWeek.getDate()).padStart(2, "0");
        mm2 = String(lastWeek.getMonth() + 1).padStart(2, "0");
        yyyy2 = lastWeek.getFullYear();
        if (this.config.date !== todayDate || this.isMobile()) {
          this.config.horodatage = yyyy2 + "-" + mm2 + "-" + dd2;
          this.config.title = lastWeek.toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } else {
          this.testMemeHeure = true;
          this.config.horodatage =
              yyyy2 + "-" + mm2 + "-" + dd2 + " " + hh + ":" + minutes + ":" + ss;
          this.config.title =
              lastWeek.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              hh +
              "h" +
              minutes;
        }
        break;
      case "Mois dernier":
        const lastMonth = this.getSameDay(dateChosen, true);
        dd2 = String(lastMonth.getDate()).padStart(2, "0");
        mm2 = String(lastMonth.getMonth() + 1).padStart(2, "0");
        yyyy2 = lastMonth.getFullYear();
        if (this.config.date !== todayDate || this.isMobile()) {
          this.config.horodatage = yyyy2 + "-" + mm2 + "-" + dd2;
          this.config.title = lastMonth.toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } else {
          this.testMemeHeure = true;
          this.config.horodatage =
              yyyy2 + "-" + mm2 + "-" + dd2 + " " + hh + ":" + minutes + ":" + ss;
          this.config.title =
              lastMonth.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              hh +
              "h" +
              minutes;
        }
        break;
      case "Année dernière":
        const lastYear = this.getSameDay(dateChosen, false);
        dd2 = String(lastYear.getDate()).padStart(2, "0");
        mm2 = String(lastYear.getMonth() + 1).padStart(2, "0");
        yyyy2 = lastYear.getFullYear();
        if (this.config.date !== todayDate || this.isMobile()) {
          this.config.horodatage = yyyy2 + "-" + mm2 + "-" + dd2;
          this.config.title = lastYear.toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } else {
          this.testMemeHeure = true;
          this.config.horodatage =
              yyyy2 + "-" + mm2 + "-" + dd2 + " " + hh + ":" + minutes + ":" + ss;
          this.config.title =
              lastYear.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              hh +
              "h" +
              minutes;
        }
        break;
      default:
        break;
    }
    if (this.info in this.CAParService) {
      this.value.CA = this.CAParService[this.info];
    } else if (this.CA.toString() !== "") {
      this.value.CA = this.CA;
    }
    // Si on est en central et que le client n'est pas BK, utiliser la nouvelle API V2
    if (this.getGlobal &&
        ["Hier", "Semaine dernière", "Mois dernier", "Année dernière"].includes(this.info)) {
      // Calculer toutes les dates nécessaires
      const todayV2 = moment(this.myOptions.date).format("YYYY-MM-DD");
      const yesterdayV2 = moment(this.myOptions.date).subtract(1, "day").format("YYYY-MM-DD");
      const lastWeekV2 = moment(this.myOptions.date).subtract(7, "days").format("YYYY-MM-DD");
      const lastMonthV2 = moment(this.getSameDay(this.myOptions.date, true)).format("YYYY-MM-DD");
      const lastYearV2 = moment(this.getSameDay(this.myOptions.date, false)).format("YYYY-MM-DD");

      const datesFiscales = [todayV2, yesterdayV2, lastWeekV2, lastMonthV2, lastYearV2].join(",");
      let sites;
      if (Array.isArray(this.config.site)) {
        sites = this.config.site.map((si: any) => si.restaurantId).join(",");
      } else {
        sites = this.config.site.restaurantId.toString();
      }

      // Utiliser le cache partagé du store - une seule requête pour toutes les instances
      await this.$store
          .dispatch("home/getResumeData", {
            restaurantIds: sites,
            datesFiscales
          })
          .then((data: any) => {
            // Mapper les données par date
            const dateMap: { [key: string]: string } = {
              [yesterdayV2]: "Hier",
              [lastWeekV2]: "Semaine dernière",
              [lastMonthV2]: "Mois dernier",
              [lastYearV2]: "Année dernière"
            };

            // Initialiser les données pour toutes les périodes
            this.TicketsEtCouverts["Hier"] = "0/0/0";
            this.TicketsEtCouverts["Semaine dernière"] = "0/0/0";
            this.TicketsEtCouverts["Mois dernier"] = "0/0/0";
            this.TicketsEtCouverts["Année dernière"] = "0/0/0";

            if (Array.isArray(data)) {
              for (const item of data) {
                const period = dateMap[item.datefiscale];
                if (period) {
                  this.TicketsEtCouverts[period] = `${item.nbTickets || 0}/${item.nbTables || 0}/${item.nbCouverts || 0}`;

                  // Appliquer les données seulement pour la période courante de cette instance
                  if (period === this.info) {
                    // Stocker les données brutes pour le cache
                    this.cachedResumeDataItem = item;

                    // Appliquer les valeurs
                    this.updateValuesFromCachedData();
                  }
                }
              }
            }
          });
    } else if (
        ["Hier", "Semaine dernière", "Mois dernier", "Année dernière"].includes(
            this.info
        )
    ) {
      // Logique existante pour les autres cas
      switch (this.info) {
        case "Hier":
          const yesterday = new Date(this.myOptions.date);
          yesterday.setDate(this.myOptions.date.getDate() - 1);
          this.config.date = moment(yesterday).format("YYYY-MM-DD");
          break;
        case "Semaine dernière":
          const lastWeek = new Date(this.myOptions.date);
          lastWeek.setDate(this.myOptions.date.getDate() - 7);
          this.config.date = moment(lastWeek).format("YYYY-MM-DD");
          break;
        case "Mois dernier":
          this.config.date = moment(
              this.getSameDay(this.myOptions.date, true)
          ).format("YYYY-MM-DD");
          break;
        case "Année dernière":
          this.config.date = moment(
              this.getSameDay(this.myOptions.date, false)
          ).format("YYYY-MM-DD");
          break;
      }
      let url: string;
      if (todayDate === moment(this.myOptions.date).format("YYYY-MM-DD")) {
        url = this.isTTC
            ? jsonURL.updateTicketsEtCouvertsHeureEtServicePerso
            : jsonURL.updateTicketsEtCouvertsHTHeureEtServicePerso;
      } else {
        url = this.isTTC
            ? jsonURL.updateTicketsEtCouvertsServicePerso
            : jsonURL.updateTicketsEtCouvertsHTServicePerso;
      }
      await this.$store
          .dispatch("home/getHomeData", {config: this.config, WS: url})
          .then((data: any) => {
            this.TicketsEtCouverts["Hier"] = "0/0/0";
            this.TicketsEtCouverts["Semaine dernière"] = "0/0/0";
            this.TicketsEtCouverts["Mois dernier"] = "0/0/0";
            this.TicketsEtCouverts["Année dernière"] = "0/0/0";
            this.CACouvertsReel = 0;
            this.CATicketsReel = 0;
            this.CATablesReel = 0;
            for (const key in data) {
              if (
                  data.hasOwnProperty(key) &&
                  ["GLOBAL", key].includes(this.myOptions.service)
              ) {
                const CABuff = Number(data[key][3]);
                this.value.CA += CABuff;
                this.TicketsEtCouverts[this.info] = this.TicketsEtCouverts[
                    this.info
                    ]
                    .split("/")
                    .map((num, idx) =>
                        (Number(num) + Number(data[key][idx])).toString()
                    )
                    .join("/");
                if (data[key][0] > 0) {
                  this.CATicketsReel += CABuff;
                }
                if (data[key][1] > 0) {
                  this.CATablesReel += CABuff;
                }
                if (data[key][2] > 0) {
                  this.CACouvertsReel += CABuff;
                }
              }
            }
          });
    }

    if (this.getGlobal && this.client === "BK" && !this.isMobile() && false) {
      let value: number;
      let tabBuff: number[];
      await this.$store
          .dispatch("home/getHomeData", {
            config: this.config,
            WS: jsonURL.updateNbTicketsRepasEmployes,
          })
          .then((data: any) => {
            for (const key of Object.keys(data)) {
              value = data[key] !== undefined ? parseFloat(data[key][0]) : 0;
              if (
                  value > 0 &&
                  ["GLOBAL", this.myOptions.service].includes(key)
              ) {
                tabBuff = [value, 0, 0];
                this.TicketsEtCouverts[this.info] = this.TicketsEtCouverts[
                    this.info
                    ]
                    .split("/")
                    .map((num, idx) =>
                        (Number(num) + Number(tabBuff[idx])).toString()
                    )
                    .join("/");
                // console.log(this.TicketsEtCouverts[this.info]);
              }
            }
          });
    }

    if (this.info in this.TicketsEtCouverts) {
      const tabBuff = this.TicketsEtCouverts[this.info].split("/");
      this.value.Tickets = Number(tabBuff[0]);
      this.value.Tables = Number(tabBuff[1]);
      this.value.Couverts = Number(tabBuff[2]);
    }
    this.reRender = !this.reRender;
    this.configIsReady = true;
    this.$emit("renderFinished", true);
  }

  public getSameDay(date: Date, forLastMonth: boolean): Date {
    const nbWeek = Math.floor((date.getDate() - 1) / 7) + 1;
    const dayOfWeek = date.getDay();
    const firstDay = forLastMonth
      ? new Date(date.getFullYear(), date.getMonth() - 1, 1)
      : new Date(date.getFullYear() - 1, date.getMonth(), 1);
    let dayOfWeekCounter = firstDay.getDay();
    let nbWeekCounter = 1;
    let counter = 0;

    while (dayOfWeekCounter !== dayOfWeek || nbWeekCounter !== nbWeek) {
      firstDay.setDate(firstDay.getDate() + 1);
      dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
      counter++;
      if (counter % 7 === 0) {
        nbWeekCounter++;
      }
    }

    return firstDay;
  }

  public get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  public get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }

  public get client(): string {
    return this.$store.getters["getClient"];
  }

  private updateValuesFromCachedData() {
    if (!this.cachedResumeDataItem) {
      return;
    }

    const item = this.cachedResumeDataItem;

    // Gérer le nouveau format des données avec TTC/HT
    const caValue = typeof item.caEncaisse === "object"
      ? (this.isTTC ? item.caEncaisse.ttc : item.caEncaisse.ht)
      : Number(item.caEncaisse || 0);

    this.value.CA = Number(caValue);
    this.value.Tickets = Number(item.nbTickets || 0);
    this.value.Tables = Number(item.nbTables || 0);
    this.value.Couverts = Number(item.nbCouverts || 0);

    this.CATicketsReel = item.nbTickets > 0 ? Number(caValue) : 0;
    this.CATablesReel = item.nbTables > 0 ? Number(caValue) : 0;
    this.CACouvertsReel = item.nbCouverts > 0 ? Number(caValue) : 0;

    // Forcer le re-render
    this.reRender = !this.reRender;
    this.$emit("renderFinished", true);
  }
}
